import { ChangeEvent } from "react";
import { FormGroup, styled } from "@mui/material";

import { usePersonalLayerParams, usePersonalLayers } from "hooks/layerHooks";
import { PersonalLayer } from "types/types";

import { PersonalLayerItem } from "components/layer/PersonalLayerItem";

interface Props {}

export function SelectPersonalLayer(props: Props) {
  const { data: personalLayers } = usePersonalLayers();
  const {
    selectedPersonalLayerIds,
    updatePersonalLayerParams,
    removePersonalLayerParams,
  } = usePersonalLayerParams();

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    updatePersonalLayerParams(
      +(event.target.value || ""),
      event.target.checked
    );
  }

  return (
    <StyledFormGroup onChange={handleChange}>
      {(personalLayers || []).map((layer: PersonalLayer, index: number) => (
        <PersonalLayerItem
          key={layer.id}
          personalLayer={layer}
          selectedPersonalLayerIds={selectedPersonalLayerIds}
          removePersonalLayerParams={removePersonalLayerParams}
        />
      ))}
    </StyledFormGroup>
  );
}

const StyledFormGroup = styled(FormGroup)`
  display: unset;
  margin-top: ${({ theme }) => theme.spacing(-0.5)};

  
`;
